import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../context/AuthContext";

const PublicRoute = ({ children }) => {
  const { isLoggedIn, loading } = useAdminAuth();

  if (loading) return <div>Loading...</div>;

  return isLoggedIn ? <Navigate to="/admin/dashboard" /> : children;
};

export default PublicRoute;
